import React from 'react';
import { useSelector } from 'react-redux';
import { waveForIdSelector } from '../../wave/selectors/wave.selectors';
import { WaveId } from '../../wave/types/wave.type';
import { useStrip } from '../hooks/useStrip';
import { getContent } from '../utils/common-graph.utils';
import { squareToPixel } from '../utils/graph.utils';
import { getConfigForWave } from '../utils/laddergram';

interface Props {
  waveId: WaveId;
}

const ITEM_SIZE = squareToPixel(3 / 8);

export const LaddergramItem: React.FC<Props> = ({ waveId }) => {
  const { xScale } = useStrip();
  const wave = useSelector(waveForIdSelector(waveId));

  if (wave == null) {
    return null;
  }

  const xOffset = xScale((wave.onset + wave.offset) / 2) - ITEM_SIZE / 2;
  const { color, yOffset, bordered } = getConfigForWave(wave);

  const withContainer = (Content: JSX.Element) => {
    return <g transform={`translate(${xOffset}, ${yOffset})`}>{Content}</g>;
  };
  return withContainer(getContent(wave, { color, bordered, size: ITEM_SIZE }));
};
